import { render, staticRenderFns } from "./BestPeriods.vue?vue&type=template&id=827cd82c"
import script from "./BestPeriods.vue?vue&type=script&lang=js"
export * from "./BestPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports